import BookingsList from '../bookings/BookingsList';

export default function Bookings() {
  return (
    <div className="container">
      <h1 style={{ marginBottom: 0 }}>Bookings</h1>
      <p className="muted" style={{ marginTop: 4, marginBottom: 24 }}>
        Every captomi-office booking across all tenants. Read-only — re-send confirmation is
        the only action.
      </p>
      <BookingsList />
    </div>
  );
}
